const getInappSlug = (inappsIdArray, gameId) => {
    const re = new RegExp(`${gameId}.([^\/]+)`);
    return inappsIdArray.filter(str => str && str.match(re)?.[1]).map(str => str.match(re)[1]);
}

export default getInappSlug;